export default `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024">
    <path d="M1024.001 529.33h-157.539v472.615h-236.308v-315.076h-236.308v315.076h-236.308v-472.615h-157.539l516.726-507.274z"></path>
</svg>
`;
